var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log"},[_c('FilterForm',{attrs:{"fields":_vm.fields},on:{"submit":_vm.filter}}),_c('BasicTable',{attrs:{"tableData":[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }